import { c as _c } from "react/compiler-runtime";
import type { ApiCommunityMemberOverview } from "@/generated/models/ApiCommunityMemberOverview";
import { formatLargeNumber, formatNumberWithCommasOrDash, getTimeAgoShort } from "@/helpers/Helpers";
import UserLevel from "@/components/user/utils/level/UserLevel";
import UserCICTypeIcon from "@/components/user/utils/user-cic-type/UserCICTypeIcon";
import { isEthereumAddress, isAutoGeneratedHandle } from "@/helpers/AllowlistToolHelpers";
import { ImageScale, getScaledImageUri } from "@/helpers/image.helpers";
import Image from "next/image";
import Link from "next/link";
export default function CommunityMembersMobileCard(t0) {
  const $ = _c(82);
  const {
    member,
    rank
  } = t0;
  const isNotProfile = isEthereumAddress(member.detail_view_key);
  const isProfile = !isNotProfile;
  const textColorClass = isProfile ? "tw-text-iron-50" : "tw-text-iron-400";
  const path = `/${member.detail_view_key}`;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== member.detail_view_key || $[1] !== member.display || $[2] !== member.last_activity || $[3] !== member.level || $[4] !== member.pfp || $[5] !== path || $[6] !== rank || $[7] !== textColorClass) {
    const now = Date.now();
    T0 = Link;
    t4 = path;
    t5 = "tw-flex tw-flex-col tw-gap-y-3 tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-900/80 tw-p-3 tw-no-underline tw-shadow-sm tw-shadow-black/20 tw-backdrop-blur-md tw-transition-all tw-duration-200 active:tw-bg-iron-800";
    t1 = "tw-flex tw-w-full tw-justify-between";
    let t6;
    if ($[14] !== rank) {
      t6 = <span className="tw-flex-shrink-0 tw-text-xs tw-text-iron-400">#{rank}</span>;
      $[14] = rank;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    let t7;
    if ($[16] !== member.display || $[17] !== member.pfp) {
      t7 = member.pfp && <Image src={getScaledImageUri(member.pfp, ImageScale.W_AUTO_H_50)} alt={`${member.display} avatar`} fill={true} unoptimized={true} className="tw-object-contain" />;
      $[16] = member.display;
      $[17] = member.pfp;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    let t8;
    if ($[19] !== t7) {
      t8 = <div className="tw-relative tw-flex tw-size-11 tw-flex-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-md tw-bg-iron-900 tw-ring-1 tw-ring-white/10">{t7}</div>;
      $[19] = t7;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    const t9 = `tw-overflow-hidden ${isEthereumAddress(member.detail_view_key) || isAutoGeneratedHandle(member.detail_view_key) ? "tw-max-w-48 tw-truncate" : ""}`;
    const t10 = `tw-text-sm tw-font-medium ${textColorClass}`;
    let t11;
    if ($[21] !== member.display || $[22] !== t10) {
      t11 = <span className={t10}>{member.display}</span>;
      $[21] = member.display;
      $[22] = t10;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    let t12;
    if ($[24] !== t11 || $[25] !== t9) {
      t12 = <div className={t9}>{t11}</div>;
      $[24] = t11;
      $[25] = t9;
      $[26] = t12;
    } else {
      t12 = $[26];
    }
    let t13;
    if ($[27] !== member.level) {
      t13 = <UserLevel level={member.level} size="xs" />;
      $[27] = member.level;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    let t14;
    if ($[29] !== t12 || $[30] !== t13) {
      t14 = <div className="tw-flex tw-min-w-0 tw-flex-col tw-items-start tw-gap-y-1">{t12}{t13}</div>;
      $[29] = t12;
      $[30] = t13;
      $[31] = t14;
    } else {
      t14 = $[31];
    }
    if ($[32] !== t14 || $[33] !== t6 || $[34] !== t8) {
      t2 = <div className="tw-flex tw-items-center tw-gap-x-2">{t6}{t8}{t14}</div>;
      $[32] = t14;
      $[33] = t6;
      $[34] = t8;
      $[35] = t2;
    } else {
      t2 = $[35];
    }
    t3 = typeof member.last_activity === "number" && <div className="tw-ml-auto tw-flex tw-items-center tw-gap-x-1 tw-self-start"><span className="tw-text-xs tw-text-iron-400">Last Seen</span><span className="tw-text-xs tw-text-iron-400">{getTimeAgoShort(member.last_activity, now, true)} ago</span></div>;
    $[0] = member.detail_view_key;
    $[1] = member.display;
    $[2] = member.last_activity;
    $[3] = member.level;
    $[4] = member.pfp;
    $[5] = path;
    $[6] = rank;
    $[7] = textColorClass;
    $[8] = T0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    T0 = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
  }
  let t6;
  if ($[36] !== t1 || $[37] !== t2 || $[38] !== t3) {
    t6 = <div className={t1}>{t2}{t3}</div>;
    $[36] = t1;
    $[37] = t2;
    $[38] = t3;
    $[39] = t6;
  } else {
    t6 = $[39];
  }
  let t7;
  if ($[40] !== member.tdh) {
    t7 = member.tdh === 0 ? "-" : formatLargeNumber(member.tdh);
    $[40] = member.tdh;
    $[41] = t7;
  } else {
    t7 = $[41];
  }
  let t8;
  if ($[42] !== t7) {
    t8 = <span className="tw-text-xs tw-font-semibold tw-text-iron-50">{t7}</span>;
    $[42] = t7;
    $[43] = t8;
  } else {
    t8 = $[43];
  }
  let t9;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="tw-text-xxs tw-text-iron-400">TDH</span>;
    $[44] = t9;
  } else {
    t9 = $[44];
  }
  let t10;
  if ($[45] !== t8) {
    t10 = <div className="tw-flex tw-items-baseline tw-gap-x-1">{t8}{t9}</div>;
    $[45] = t8;
    $[46] = t10;
  } else {
    t10 = $[46];
  }
  let t11;
  if ($[47] !== member.xtdh) {
    t11 = member.xtdh === 0 ? "-" : formatLargeNumber(Math.round(member.xtdh));
    $[47] = member.xtdh;
    $[48] = t11;
  } else {
    t11 = $[48];
  }
  let t12;
  if ($[49] !== t11) {
    t12 = <span className="tw-text-xs tw-font-semibold tw-text-iron-50">{t11}</span>;
    $[49] = t11;
    $[50] = t12;
  } else {
    t12 = $[50];
  }
  let t13;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="tw-text-xxs tw-text-iron-400">xTDH</span>;
    $[51] = t13;
  } else {
    t13 = $[51];
  }
  let t14;
  if ($[52] !== t12) {
    t14 = <div className="tw-flex tw-items-baseline tw-gap-x-1">{t12}{t13}</div>;
    $[52] = t12;
    $[53] = t14;
  } else {
    t14 = $[53];
  }
  let t15;
  if ($[54] !== member.rep) {
    t15 = formatNumberWithCommasOrDash(member.rep);
    $[54] = member.rep;
    $[55] = t15;
  } else {
    t15 = $[55];
  }
  let t16;
  if ($[56] !== t15) {
    t16 = <span className="tw-text-xs tw-font-semibold tw-text-iron-50">{t15}</span>;
    $[56] = t15;
    $[57] = t16;
  } else {
    t16 = $[57];
  }
  let t17;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="tw-text-xxs tw-text-iron-400">REP</span>;
    $[58] = t17;
  } else {
    t17 = $[58];
  }
  let t18;
  if ($[59] !== t16) {
    t18 = <div className="tw-flex tw-items-baseline tw-gap-x-1">{t16}{t17}</div>;
    $[59] = t16;
    $[60] = t18;
  } else {
    t18 = $[60];
  }
  let t19;
  if ($[61] !== member.cic) {
    t19 = <div className="tw-size-4"><UserCICTypeIcon cic={member.cic} /></div>;
    $[61] = member.cic;
    $[62] = t19;
  } else {
    t19 = $[62];
  }
  let t20;
  if ($[63] !== member.cic) {
    t20 = formatNumberWithCommasOrDash(member.cic);
    $[63] = member.cic;
    $[64] = t20;
  } else {
    t20 = $[64];
  }
  let t21;
  if ($[65] !== t20) {
    t21 = <span className="tw-text-xs tw-font-semibold tw-text-iron-50">{t20}</span>;
    $[65] = t20;
    $[66] = t21;
  } else {
    t21 = $[66];
  }
  let t22;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <span className="tw-text-xxs tw-text-iron-400">NIC</span>;
    $[67] = t22;
  } else {
    t22 = $[67];
  }
  let t23;
  if ($[68] !== t19 || $[69] !== t21) {
    t23 = <div className="tw-flex tw-items-center tw-gap-x-1">{t19}{t21}{t22}</div>;
    $[68] = t19;
    $[69] = t21;
    $[70] = t23;
  } else {
    t23 = $[70];
  }
  let t24;
  if ($[71] !== t10 || $[72] !== t14 || $[73] !== t18 || $[74] !== t23) {
    t24 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-x-3 tw-whitespace-nowrap">{t10}{t14}{t18}{t23}</div>;
    $[71] = t10;
    $[72] = t14;
    $[73] = t18;
    $[74] = t23;
    $[75] = t24;
  } else {
    t24 = $[75];
  }
  let t25;
  if ($[76] !== T0 || $[77] !== t24 || $[78] !== t4 || $[79] !== t5 || $[80] !== t6) {
    t25 = <T0 href={t4} className={t5}>{t6}{t24}</T0>;
    $[76] = T0;
    $[77] = t24;
    $[78] = t4;
    $[79] = t5;
    $[80] = t6;
    $[81] = t25;
  } else {
    t25 = $[81];
  }
  return t25;
}